import { MmseScreen } from "app/screens/residents/show/MmseScreen";

export default function MMSEPage() {
  return <MmseScreen />;
}
